export default __webpack_public_path__ + "static/media/tisco.9e503557.svg";